export default __webpack_public_path__ + "static/media/Resource Tracking feature.c8759230.png";